module.exports = __webpack_public_path__ + "static/media/p0203.08e650a1.png";